import type { IHttpError } from '@wix/http-client';

export function getHttpErrorInfo(httpError: IHttpError) {
  return {
    request: {
      baseURL: httpError.config.baseURL,
      url: httpError.config.url,
      method: httpError.config.method,
      headers: httpError.config.headers,
      data: httpError.config.data,
    },
    response: {
      code: httpError.code,
      message: httpError.message,
      status: httpError.response?.status,
      headers: httpError.response?.headers,
      data: httpError.response?.data,
    },
  };
}
